<template>

	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

            <div>

              <template>
                <h5>申込詳細</h5>
                <hr>

                <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">販売者情報</div>
                <ul>
                  <li class="row" @click="jumpUser(seller['id'])">
                    <span class="col-md-3 hed">店舗名</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      <strong v-if="seller['legal_person']==1">{{ cinit(seller['corp_name'], '-') }}</strong>
                      <strong v-else-if="seller['legal_person']==0">{{ cinit(seller['store_name'], '-') }}</strong>
                    </span>
                  </li>
                  <li class="row" @click="jumpUser(seller['id'])">
                    <span class="col-md-3 hed">担当者名（カナ）</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      <span>{{ cinit(seller['first_name'], '-') }}　{{ cinit(seller['last_name'], '-') }}　（{{ cinit(seller['phonetic_first_name'], '-') }}　{{ cinit(seller['phonetic_last_name'], '-') }}）</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">住所</span>
                    <span class="col-md-8 dat">
                      <p>〒{{ cinit(seller['postal_code'], '-') }}</p>
                      <p>{{ cinit(seller['region'], '-') }}{{ cinit(seller['address_1'], '-') }}{{ cinit(seller['address_2'], '-') }}</p>
                      <p>℡ {{ cinit(seller['phone'], '-') }}</p>                  
                    </span>
                  </li>
                  <!--
                  <li v-for="(value, key) in seller">
                    <template v-if="exchange_db_orders(key, 2) != ''">
                      <template>
                        <span class="col-md-3 hed">{{ exchange_db_orders(key, 2) }}</span><span class="col-md-8 dat">{{ value }}</span>
                      </template>
                    </template>
                  </li>
                  -->
                </ul>

                <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">申込者情報</div>
                <ul>
                  <li class="row" @click="jumpUser(buyer['id'])">
                    <span class="col-md-3 hed">メールアドレス [ユーザID]</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      <span>{{ cinit(buyer['email'], '-') }} [{{ cinit(buyer['id'], '-') }}]</span>
                    </span>
                  </li>
                  <li class="row" @click="jumpUser(buyer['id'])">
                    <span class="col-md-3 hed">名前（カナ）</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      <span>{{ cinit(buyer['first_name'], '-') }}　{{ cinit(buyer['last_name'], '-') }}　（{{ cinit(buyer['phonetic_first_name'], '-') }}　{{ cinit(buyer['phonetic_last_name'], '-') }}）</span>
                    </span>
                  </li>
                  <li class="row" @click="jumpUser(buyer['id'])">
                    <span class="col-md-3 hed">ハンドルネーム</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;">
                      <span>{{ cinit(buyer['nickname'], '-') }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">性別</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(gender, buyer['gender']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">住所</span>
                    <span class="col-md-8 dat">
                      <p>〒{{ cinit(buyer['postal_code'], '-') }}</p>
                      <p>{{ cinit(buyer['region'], '-') }}{{ cinit(buyer['address_1'], '-') }}{{ cinit(buyer['address_2'], '-') }}</p>
                      <p>℡ {{ cinit(buyer['phone'], '-') }}</p>                  
                    </span>
                  </li>
                  <!--
                  <li v-for="(value, key) in buyer">
                    <template v-if="exchange_db_orders(key, 1) != ''">
                      <template>
                        <span class="col-md-3 hed">{{ exchange_db_orders(key, 1) }}</span><span class="col-md-8 dat">{{ value }}</span>
                      </template>
                    </template>
                  </li>
                  -->
                </ul>

                <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">申込情報</div>
                <ul>
                  <li class="row">
                    <span class="col-md-3 hed">コース申し込みID</span>
                    <span class="col-md-8 dat">
                      <span>{{ order['id'] }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">区分</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(order_type, order['type']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">返答の仕方</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(how_to_reply, order['how_to_reply']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">申込時コメント</span>
                    <span class="col-md-8 dat">
                      <span>{{ order['comment'] }}</span>
                    </span>
                  </li>

                  <li class="row">
                    <span class="col-md-3 hed">申込商品</span>
                    <span class="col-md-8 dat" style="cursor: pointer;color: #007bff;text-decoration: none;background-color: transparent;" @click="jumpProductDetail(product['id'])">
                      <span>{{ product['title'] }}</span>
                    </span>
                  </li>

                  <template v-if="String(order['type']) == '1'">
                    <li class="row">
                      <span class="col-md-3 hed">試弾希望日時１</span>
                      <span class="col-md-8 dat">
                        <span>{{ cinit(order['reservation_date_1'], '-') }}　{{ cinit(order['reservation_time_from_1'], '-') }}　～　{{ cinit(order['reservation_time_to_1'], '-') }}</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">試弾希望日時２</span>
                      <span class="col-md-8 dat">
                        <span>{{ cinit(order['reservation_date_2'], '-') }}　{{ cinit(order['reservation_time_from_2'], '-') }}　～　{{ cinit(order['reservation_time_to_2'], '-') }}</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">試弾希望日時３</span>
                      <span class="col-md-8 dat">
                        <span>{{ cinit(order['reservation_date_3'], '-') }}　{{ cinit(order['reservation_time_from_3'], '-') }}　～　{{ cinit(order['reservation_time_to_3'], '-') }}</span>
                      </span>
                    </li>
                  </template>

                  <template v-if="String(order['type']) == '2'">
                    <li class="row">
                      <span class="col-md-3 hed">請求金額</span>
                      <span class="col-md-8 dat">
                        <span>{{ order['billing_price'] }} 円</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">お支払方法</span>
                      <span class="col-md-8 dat">
                        <span>{{ get_hash_value(payment_method, order['payment_method']) }}</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">名前（カナ）</span>
                      <span class="col-md-8 dat">
                        <span>{{ cinit(order['first_name'], '-') }}　{{ cinit(order['last_name'], '-') }}　（{{ cinit(order['phonetic_first_name'], '-') }}　{{ cinit(order['phonetic_last_name'], '-') }}）</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">住所</span>
                      <span class="col-md-8 dat">
                        <p>〒{{ cinit(order['postal_code'], '-') }}</p>
                        <p>{{ cinit(order['region'], '-') }}{{ cinit(order['address'], '-') }}</p>
                        <p>℡ {{ cinit(order['phone'], '-') }}</p>                  
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">設置階数</span>
                      <span class="col-md-8 dat">
                        <span>{{ order['installation_floor'] }} 階</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">エレベーター</span>
                      <span class="col-md-8 dat">
                        <span>{{ get_hash_value(elevator, order['elevator']) }}</span>
                      </span>
                    </li>
                    <li class="row">
                      <span class="col-md-3 hed">支払いステータス</span>
                      <span class="col-md-8 dat">
                        <span>{{ get_hash_value(payment_status, order['payment_status']) }}</span>
                      </span>
                    </li>
                  </template>

                  <li class="row">
                    <span class="col-md-3 hed">ステータス</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(status, order['status']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">メモ</span>
                    <span class="col-md-8 dat">
                      <span>{{ order['memo'] }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">管理者メモ</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['contents'], '-') }}</span>-->
                      <textarea placeholder="" v-model="order['admin_memo']" class="w-100" rows="6"></textarea>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">申込日</span>
                    <span class="col-md-8 dat">
                      <span>{{ convert_jst_for_message(cinit(order['created_at'], '-')) }}</span>
                    </span>
                  </li>
                </ul>
                <div class="form-group">
                    <div class="b100 col-sm-11">
                        <a href="javascript:void(0)" @click="update_memo(order['id'], order['admin_memo'])" class="bs100 btn btn-primary">更新する</a>
                    </div>
                </div>

                <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">評価情報（販売者）</div>
                <ul>
                  <li class="row">
                    <span class="col-md-3 hed">年齢</span>
                    <span class="col-md-8 dat">
                      <span>{{ cinit(review['seller']['old'], '-') }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">ピアノ本体以外に購入したもの、その他コメントなど</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['comment'], '-') }}</span>-->
                      <textarea placeholder="" v-model="review['seller']['comment']" class="w-100" rows="6"></textarea>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">評価コメント</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['contents'], '-') }}</span>-->
                      <textarea placeholder="" v-model="review['seller']['contents']" class="w-100" rows="6"></textarea>
                    </span>
                  </li>
                  <template v-if="cinit(review['seller']['review_comment_id'], '') != ''">
                    <li class="row">
                      <span class="col-md-3 hed">評価コメントへの返答</span>
                      <span class="col-md-8 dat">
                        <!--<span>{{ cinit(review['seller']['contents'], '-') }}</span>-->
                        <textarea placeholder="" v-model="review['seller']['review_comment_contents']" class="w-100" rows="6"></textarea>
                      </span>
                    </li>
                  </template>
                  <li class="row">
                    <span class="col-md-3 hed">評価日時</span>
                    <span class="col-md-8 dat">
                      <span>{{ convert_jst_for_message(cinit(review['seller']['created_at'], '-')) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">1.商品の満足度(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['product_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['product_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">2.掲載情報の正確性(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['infomation_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['infomation_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">3.スタッフの対応(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['staff_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['staff_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">4.決済方法(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['payment_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['payment_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">5.梱包(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['packing_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['packing_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">6.配送(5段階評価)</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['seller']['delivery_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['seller']['delivery_evaluation']) }}</span>
                    </span>
                  </li>
                </ul>
                <div class="form-group">
                    <div class="b100 col-sm-11">
                        <a href="javascript:void(0)" @click="seller_review_update(review['seller']['id'], review['seller']['comment'], review['seller']['contents'], review['seller']['review_comment_id'], review['seller']['review_comment_contents'])" class="bs100 btn btn-primary">更新する</a>
                    </div>
                </div>

                <div class="mt-5 mb-3 col-12 text-center" style="font-size: 1.3rem;">評価情報（商品）</div>
                <ul>
                  <li class="row">
                    <span class="col-md-3 hed">年齢</span>
                    <span class="col-md-8 dat">
                      <span>{{ cinit(review['product']['old'], '-') }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">評価コメント</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['contents'], '-') }}</span>-->
                      <textarea placeholder="" v-model="review['product']['contents']" class="w-100" rows="6"></textarea>
                    </span>
                  </li>
                  <template v-if="cinit(review['product']['review_comment_id'], '') != ''">
                    <li class="row">
                      <span class="col-md-3 hed">評価コメントへの返答</span>
                      <span class="col-md-8 dat">
                        <!--<span>{{ cinit(review['product']['contents'], '-') }}</span>-->
                        <textarea placeholder="" v-model="review['product']['review_comment_contents']" class="w-100" rows="6"></textarea>
                      </span>
                    </li>
                  </template>
                  <li class="row">
                    <span class="col-md-3 hed">評価日時</span>
                    <span class="col-md-8 dat">
                      <span>{{ convert_jst_for_message(cinit(review['product']['created_at'], '-')) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">1.響き・音色</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['tone_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['product']['tone_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">2.タッチ感</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['touch_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['product']['touch_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">3.つくりの良さ</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['made_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['product']['made_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">4.デザイン</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['design_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['product']['design_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">5.維持、管理のしやすさ</span>
                    <span class="col-md-8 dat">
                      <!--<span>{{ cinit(review['product']['maintain_evaluation'], '-') }}</span>-->
                      <span>{{ get_hash_value(evaluation, review['product']['maintain_evaluation']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">このピアノを使う人</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(how_use, review['product']['how_use']) }}</span>
                    </span>
                  </li>
                  <li class="row">
                    <span class="col-md-3 hed">このピアノの使い方</span>
                    <span class="col-md-8 dat">
                      <span>{{ get_hash_value(who_use, review['product']['who_use']) }}</span>
                    </span>
                  </li>
                </ul>
                <div class="form-group">
                    <div class="b100 col-sm-11">
                        <a href="javascript:void(0)" @click="product_review_update(review['product']['id'], review['product']['contents'], review['product']['review_comment_id'], review['product']['review_comment_contents'])" class="bs100 btn btn-primary">更新する</a>
                    </div>
                </div>
              </template>

            </div>

					</div>

				</div>
			</div>

		</b-container>
	</div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import VueJsPaginate from "vuejs-paginate";

export default {
	name: 'AdminMessage',
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  data() {
		const legal_person = [
      {"no":"1","name":"法人"},
      {"no":"0","name":"個人"},
    ];
		const gender = [
      {"no":"1","name":"男"},
      {"no":"2","name":"女"},
    ];
		const user_type = [
      {"no":"","name":"全て"},
      {"no":"1","name":"一般"},
      {"no":"2","name":"販売者"},
      {"no":"3","name":"スタッフ"},
    ];
		const del_flg = [
      {"no":"0","name":"有効"},
      {"no":"1","name":"無効"},
    ];
		const identification_flg = [
      {"no":"0","name":"未完了"},
      {"no":"1","name":"申請中"},
      {"no":"2","name":"エラー"},
      {"no":"3","name":"完了"},
    ];
    const evaluation = [
      {"no":"1","name":"とてもよい"},
      {"no":"2","name":"よい"},
      {"no":"3","name":"ふつう"},
      {"no":"4","name":"あまりよくない"},
      {"no":"5","name":"よくない"},
    ];
		const who_use = [
      {"no":"1","name":"子供"},
			{"no":"2","name":"大人"},
			{"no":"3","name":"家族共用"},
			{"no":"4","name":"演奏家"},
			{"no":"5","name":"生徒"},
			{"no":"6","name":"不特定多数"},
			{"no":"7","name":"その他"},
		];
		const how_use = [
      {"no":"1","name":"普段用"},
			{"no":"2","name":"ピアノレッスン用"},
			{"no":"3","name":"サロン演奏用"},
			{"no":"4","name":"コンサートホールなど公共施設用"},
			{"no":"5","name":"その他"},
		];
		const order_type = [
      {"no":"1","name":"試弾"},
      {"no":"2","name":"購入"},
    ];
		const how_to_reply = [
      {"no":"1","name":"メッセージ"},
      {"no":"2","name":"電話"},
    ];
		const payment_method = [
			{"no":"1","name":"クレジットカード"},
			{"no":"2","name":"銀行振込"},
			{"no":"3","name":"その他"},
    ];
		const elevator = [
      {"no":"1","name":"あり"},
      {"no":"2","name":"なし"},
    ];
		const status = [
			{"no":"0","name":"申し込み"},
			{"no":"2","name":"完了"},
			{"no":"9","name":"キャンセル"},
    ];
		const payment_status = [
			{"no":"0","name":"未払い"},
			{"no":"1","name":"振込済み"},
			{"no":"2","name":"振込確認中"},
			{"no":"3","name":"保留"},
			{"no":"4","name":"完了（支払い済み）"},
			{"no":"9","name":"キャンセル"},
    ];
    return {
      legal_person,
      gender,
      user_type,
      del_flg,
      identification_flg,
      evaluation,
      who_use,
      how_use,
      order_type,
      how_to_reply,
      payment_method,
      elevator,
      status,
      payment_status,

      order_id: null,
      all_order: {},

      seller: {},
			buyer: {},
			order: {},
			review: {},
			product: {},
      isError: false,
    }
  },
  methods: {
    jumpProductDetail: function (id) {
      window.open('/product/'+String(id), '_blank')
      return false;
    },
    jumpUser: function (id) {
      window.open('/mypage?page=3&users_id='+id, '_blank')
      return false;
      // this.$router.push({path: '/mypage', query: {page: 3, users_id: id}});
      // return false;
    },
		async get_order() {
			this.$store.dispatch('order/get_admin_order', {
        order_id: this.order_id,
      }).then(res => {
				console.log(res);
				this.all_order = res.data.order;
        this.seller = this.all_order.seller;
        this.buyer = this.all_order.buyer;
        this.order = this.all_order.order;
        this.review = this.all_order.review;
        this.product = this.all_order.product;
				console.log(this.seller);
				console.log(this.buyer);
				console.log(this.order);
				console.log(this.review);
				console.log(this.product);
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
    async product_review_update(id, contents, review_comment_id, review_comment_contents) {
      this.$store.dispatch('order/put_admin_review', {
        id: id,
        comment: '',
        contents: contents,
        review_comment_id: this.cinit(review_comment_id, ''),
        review_comment_contents: this.cinit(review_comment_contents, ''),
      }).then(res => {
        console.log(res);
        alert('更新が完了しました');
      }, error => {
        console.log('error発生');
        console.log(error);
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
        });
      });
    },
    async seller_review_update(id, comment, contents, review_comment_id, review_comment_contents) {
      this.$store.dispatch('order/put_admin_review', {
        id: id,
        comment: comment,
        contents: contents,
        review_comment_id: this.cinit(review_comment_id, ''),
        review_comment_contents: this.cinit(review_comment_contents, ''),
      }).then(res => {
        console.log(res);
        alert('更新が完了しました');
      }, error => {
        console.log('error発生');
        console.log(error);
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
        });
      });
    },
    async update_memo(orders_id, memo) {
      let form = {};
      form['orders_id'] = orders_id;
      form['memo'] = memo;
      form['admin'] = "1";
      this.$store.dispatch('order/put_order', {
        order: form,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました');
      }, error => {
        console.log('error発生');
        console.log(error);
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
        });
      });
    },

  },
  created() {
    this.order_id = this.$route.params.orders_id;
    this.get_order();
  },
}
</script>

<style>
.hed {
  padding: 4px;
  border: solid 1px #999393;
  margin-bottom: 4px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 4px;
  background-color: #ebebeb;
}
.dat {
  padding: 4px;
  border: solid 1px #999393;
  margin-bottom: 4px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 4px;
}
#download-link {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminOrderDetail.vue